// src/components/tools/DrawTool.js
import DrawIcon from "@mui/icons-material/Draw";
import StraightenIcon from "@mui/icons-material/Straighten";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import SquareFootIcon from "@mui/icons-material/SquareFoot";

export const DrawToolConfig = {
  name: "DRAW",
  tool: "DrawTool", // Match unique tool identifier
  icon: <DrawIcon />,

  children: [
    {
      name: "Length",
      tool: "Length",
      icon: <StraightenIcon />,
    },
    {
      name: "Rectangle",
      tool: "RectangleROI",
      icon: <CropSquareIcon />,
    },
    {
      name: "Ellipse (HU)",
      tool: "EllipticalROI",
      icon: <RadioButtonUncheckedIcon />,
    },
    {
      name: "Angle",
      tool: "Angle",
      icon: <SquareFootIcon />,
    },
  ],
};